<template>
  <div v-if="visible" class="vmodal">
    <transition name="vmodal-overlay-transition">
      <div v-if="visible" class="vmodal-overlay" @click.self.stop="close" />
    </transition>
    <transition name="vmodal-modal-transition">
      <div v-if="visible" class="vmodal-container" :class="{small: small}" :style="{maxWidth: max_width}">
        <div class="vmodal-header">
          <div class="vmodal-header__title">
            <slot name="title" />
          </div>
          <div class="vmodal-close close" @click="close" />
        </div>
        <div class="vmodal-container-content">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'VModal',
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    max_width: {
      type: String,
      default: '950px',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {
    document.querySelector('body').style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.querySelector('body').style.overflow = 'visible';
  },
  methods: {
    toggle(val) {
      this.$emit('change', val);
    },
    close() {
      this.toggle(false);
    },
  },
};
</script>
<style scoped>
.vmodal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate3d(0);
}
.vmodal * {
  box-sizing: border-box;
}
.vmodal-overlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (--viewport-planshet) {
    background: transparent;
  }
}
.vmodal-container {
  position: relative;
  background: var(--back);
  color: var(--text-color);
  z-index: 999;
  padding: 3rem 2rem 3rem 3rem;
  overflow: hidden;
  width: 375px;
  height: 100vh;
  @media (--viewport-planshet) {
    height: auto;
    max-height: 95vh;
    width: auto;
    max-width: 680px;
    margin: 0 2vw;
    box-shadow: 0 10px 30px rgba(120, 131, 152, 0.48);
    border-radius: 8px;
  }
}
.vmodal-container.small {
  height: auto;
  max-height: 100vh;
}
.vmodal-container-content {
  height: 100%;
  overflow-y: auto;
  padding-right: 1rem;
  -webkit-overflow-scrolling: touch;
  @media (--viewport-planshet) {
    max-height: calc(95vh - 9rem);
  }
}

.vmodal-overlay-transition-enter-active,
.vmodal-overlay-transition-leave-active {
  transition: all 50ms;
}
.vmodal-overlay-transition-enter,
.vmodal-overlay-transition-leave-active {
  opacity: 0;
}
.vmodal-modal-transition-enter-active,
.vmodal-modal-transition-leave-active {
  transition: all 400ms;
}
.vmodal-modal-transition-enter,
.vmodal-modal-transition-leave-active {
  opacity: 0;
  transform: translateY(-20px);
}
.vmodal-close {
  width: 37px;
  height: 37px;
  top: 0.5rem;
  right: 0.5rem;
  @media (--viewport-planshet) {
    top: 20px;
    width: 30px;
    height: 30px;
  }
}
.vmodal-header__title {
  color: var(--brand-color);
  text-transform: uppercase;
  font-variation-settings: 'wght' 600;
  text-align: center;
  line-height: 1.2;
  font-size: 16px;
  margin: 0 0 0.5em;
  @media (--viewport-planshet) {
    font-size: 32px;
  }
}
.vmodal-header__title > * {
  margin-bottom: 0;
}
.vmodal-close {
  position: absolute;
  top: 13px;
  right: 20px;
  width: 19px;
  height: 19px;
  cursor: pointer;
  transition: 0.4s;
  &:hover {
    transform: rotate(90deg);
  }
}
.vmodal >>> .modal-content_slot {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  line-height: 15px;
  @media (--viewport-planshet) {
    font-size: 14px;
    line-height: 20px;
  }
  @media (min-width: 1260px) {
    font-size: 18px;
    line-height: 28px;
  }
}
.vmodal >>> .modal-content_slot-close-btn {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
